<template>
    <div class="table">
        <div class="container">
            <div class="handle-box">
                <el-form :model="queryCondition" :label-position="labelPosition" label-width="110px">
                    <el-row :gutter="16">
                        <el-col :span="8">
                            <el-form-item label="料架类型名称">
                                <el-input class="handle-input" v-model="queryCondition.mateName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="料架状态">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="料架唯一编码">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16">
                        <el-col :span="8">
                            <el-form-item label="料架类型编号">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="料架空满箱状态">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="超期未周转">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16">
                        <el-col style="text-align: center;">
                            <el-button type="primary" @click="queryData">搜索</el-button>
                            <el-button type="primary">重置</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-row class="action-btn-row">
                <el-button type="primary" @click="downloadMatePart">下载</el-button>
            </el-row>
            <el-table :data="tableData" border highlight-current-row class="table">
                <el-table-column show-overflow-tooltip prop="mateCode" label="料架唯一编号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="no" label="料架类型编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="mateName" label="料架名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createDate" label="当前库存节点编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="当前库存节点名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="料架状态"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="空满箱状态"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="未周转天数"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination  @current-change="handleCurrentChange" layout="prev, pager, next" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'material-rack-item',
        data() {
            return {
                tableData: [{
                    mateCode: '123456',
                    no: '00000000',
                    mateName: 'red',
                    createDate: '2019-09-09',
                    status: '9999'
                }],
                total: 0,
                labelPosition: 'right',
                queryCondition:{
                    mateCode: '',
                    status: '',
                    date: '',
                    materialNo: '',
                    materialName: ''
                },
                applyForm: {
                    mateCode: '',
                    mateName: '',
                    applyCount: 0
                },
                applyDialog: false
            }
        },
        methods: {
            queryData(){
                console.dir(this.queryCondition);
            },
            /**
             * 翻页事件
             */
            handleCurrentChange(){

            },
            downloadMatePart(){

            }
        }
    }
</script>
<style scoped>
    .handle-input{
        width: 90%;
    }
    .action-btn-row{
        margin-bottom: 10px;
        margin-top: 10px;
    }
</style>